/**
 * A11yValue — mostra un valore visivo e ne fornisce una versione parlata naturale
 * per VoiceOver tramite testo .sr-only reale (l'aria-label su uno <span> generico
 * NON viene esposto dalle assistive technology).
 */
export const A11yValue = ({ visual, spoken, className, testId }) => (
  <span className={className} data-testid={testId}>
    <span aria-hidden="true">{visual}</span>
    <span className="sr-only">{spoken}</span>
  </span>
);
